import { useMainStore } from '../../../../../stores/mainStore.js';
import { useAlertBannerStore } from '../../../../../stores/alertBannerStore.js';

export default {
  computed: {
    cssVars() {
      const themeColor = useMainStore().getThemeHeadingColor || '#333';
      const themeColorTwo = `${themeColor}05`;
      const themeColorFive = `${themeColor}13`;
      const themeColorTwenty = `${themeColor}33`;
      return {
        '--primary-forms-color': themeColor,
        '--light-forms-color': themeColorFive,
        '--medium-forms-color': themeColorTwenty,
        '--empty-forms-color': themeColorTwo,
        '--overlay-color': useAlertBannerStore().getThemeAlertShadowOverlay,
      };
    },
  },
};
